import React from 'react';
import './ReportItem.css';

const ReportItem = ({ 
  report, 
  isSelected, 
  onSelect 
}) => {
  const handleClick = () => {
    onSelect(report);
  };

  return (
    <div
      className={`report-item ${isSelected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      <div className="report-content">
        <div className="report-info">
          <div className="report-name">
            {report.name || 'Relatório sem nome'}
          </div>
          <div className="report-id">
            ID: {report.id.substring(0, 8)}...
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportItem;
